import type * as Api from 'Api'

export const authErrorHandbook: Api.ErrorsHandbook<
  'default' | 'authentication' | 'refresh' | 'changePassword'
> = {
  default: [],
  refresh: [],
  changePassword: [
    {
      status: 1,
      code: 409,
      message: 'Повторите попытку позже',
    },
    {
      status: 1,
      code: 400,
      message: 'Неверно указан код проверки',
    },
  ],
  authentication: [
    {
      status: 1,
      code: 401,
      message: 'Email или пароль введены неверно',
    },
    {
      status: 1,
      code: 429,
      message:
        'Вы превысили число попыток авторизации, спустя время можно будет повторить',
    },
  ],
}
